import React from 'react';
import UI from '../../ui';
import ShipstationModule from '../../shipstation';

const { ShipStation } = ShipstationModule;
const { WrappedButton, WrappedButtonType } = UI;

const OrdersMarketingView = () => (
	<div className="settings-orders-orders-marketing-view">
		<div className="p-grid">
			<div className="p-col-12">
				<p>
					<b>Still shipping orders one at a time? Cutting & pasting order info?</b>
				</p>
			</div>
			<div className="p-col-12">
				<p className="marketing-text-large">
					Time to try <b>Orders</b>
				</p>
			</div>
			<div className="p-col-12">
				<iframe
					title="Order"
					src="https://player.vimeo.com/video/262321903"
					height="230px"
					width="400PX"
				/>
			</div>
			<div className="p-col-12">
				<ul>
					<li>
						<b>Import</b> online order info automatically
					</li>
					<li>
						<b>Process</b> all of your orders in minutes
					</li>
					<li>
						<b>Print</b> all of your shipping labels with one click
					</li>
					<li>
						<b>Post Back</b> shipping info to your online stores
					</li>
					<li>
						<b>Set up</b> in minutes
					</li>
				</ul>
			</div>
			<div className="p-col-12">
				<WrappedButton
					label="GET STARTED"
					buttonType={WrappedButtonType.Primary}
					onClick={() => ShipStation.goToRegistration()}
					dataqa="orders-marketing-get-started"
				/>
			</div>
		</div>
	</div>
);

export default OrdersMarketingView;
